module.exports = __webpack_public_path__ + "img/order-success.15cda2ce.svg";